import axios, { AxiosPromise } from 'axios';
import { cancelToken } from '../../utils/cancelToken';
import * as option from './query/option';
import * as trace from './query/trace';
import * as topology from './query/topology';
import * as alarm from './query/alarm';
import * as home from './query/home';
import * as profile from './query/profile';
import * as dashboard from './query/dashboard';
import * as errorLog from './query/log';
import * as settings from './query/settings';
import * as browser from './query/browser';
import * as mobile from '@/services/graphQl/query/mobile';
import * as synthetic from '@/services/graphQl/query/synthetic';
import * as k8 from '@/services/graphQl/query/k8';
import * as cloud from '@/services/graphQl/query/cloud';
import * as vm from '@/services/graphQl/query/vm';
import * as billing from '@/services/graphQl/query/billing';
import * as mq from '@/services/graphQl/query/mq';

import * as graph from './query/graph';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import { AuthService } from '../api/auth.service';
import { HOSTS, HOST_VERSIONS } from '@/services/config.js';
// import { OAP_HOST } from '../constants';
//const OAP_HOST = 'http://localhost:3000';

const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';
const query: any = {
  ...errorLog,
  ...option,
  ...trace,
  ...topology,
  ...alarm,
  ...home,
  ...profile,
  ...dashboard,
  ...settings,
  ...browser,
  ...graph,
  ...mobile,
  ...synthetic,
  ...k8,
  ...cloud,
  ...vm,
  ...billing,
  ...mq,
};

class Graph {
  private queryData: string = '';
  private service: string = HOST_VERSIONS.queryService;
  public query(queryData: string) {
    this.queryData = queryData;
    return this;
  }

  public version(version: keyof typeof HOST_VERSIONS) {
    this.service = version;
    return this;
  }

  public params(variablesData: any): AxiosPromise<any> {
    return new axiosInstance({ auth: true }).post(
      // return new axiosInstance({ auth: true }).(
      HOSTS[this.service] + '/graphql',
      {
        query: query[this.queryData],
        variables: variablesData,
      },
      {
        // cancelToken: cancelToken()
      }
    );
  }

  public graphQuery(variablesData: any, metric: any): AxiosPromise<void> {
    return new axiosInstance({ auth: true }).post(
      // return new axiosInstance({ auth: true }).(
      OAP_HOST + '/graphql',
      {
        query: query.graphQuery(metric),
        variables: variablesData,
      },
      {
        // cancelToken: cancelToken()
      }
    );
  }
}

export default new Graph();

export const grahqlQueryServiceV2 = new Graph().version('queryServiceV2');
